import { AxiosError, AxiosResponse } from "axios";
import http from "../common/http-commons";
import { IGetListRequest, IResponse, IServerError } from "../models/common";
import { GridSize } from "@mui/material";
import { DataType, FieldType } from "@websential/cosmic-v20";
import { IBCEHTSetting, IBCEHTSettingListPayload, IBCEHTSettingResponse } from "../models/BCEHTSetting";
// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const BCEHTSettingService = {
	getBCEHTSetting: async (
		data: IGetListRequest,
		navigateToLogout: (path: string) => void
	): Promise<
	IBCEHTSettingListPayload | IServerError | IResponse | IBCEHTSettingResponse[]
	> => {
		try {
			const response: AxiosResponse<IBCEHTSettingListPayload> =
				await http.get<IBCEHTSettingListPayload>(
					"/v1/bc-eht-setting/" +
						"?order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
		
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getById: async (
		taxYear: number,
		navigateToLogout: (path: string) => void
	): Promise<IBCEHTSetting | IServerError | IResponse | null | any> => {
		// if (!id) return null;
		try {
			const response: AxiosResponse<IBCEHTSetting> =
				await http.get<IBCEHTSetting>(
					`/v1/bc-eht-setting/${taxYear}/`
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 404) {
					return {
						status: false,
						message: "Not Found",
					};
				} else {
			
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any
	): Promise<IBCEHTSetting | IServerError | IResponse | any> => {
		if (requestPayload.id) {
		
			try {
				const response: AxiosResponse<IBCEHTSetting> =
					await http.put<IBCEHTSetting>(
						`/v1/bc-eht-setting/${requestPayload.taxYear}/`,
						requestPayload
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}


		try {
			const response: AxiosResponse<IBCEHTSetting> =
				await http.post<IBCEHTSetting>(
					`/v1/bc-eht-setting/`,
					requestPayload
				);

	
			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
			
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delBCEHTSetting: async (
		delPayload: any
	): Promise<string | IServerError | IResponse | any> => {
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/bc-eht-setting/${delPayload.bCEHTSettingId}/`
			);

			if (response.status === 204) {
				return "BC EHT Setting has been deleted successfully";
			} else if (response.status === 200) {
				return "BC EHT Setting has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
		
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delBulkBCEHTSetting: async (
		requestPayload: any
	): Promise<string | IServerError | IResponse> => {
		
		try {
			const response = await http.delete<string>(`/v1/bc-eht-setting/`, {
				data: requestPayload.bCEHTSettingIds,
			});
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
		
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getGetBCEHTSettingDDL: async (
		clientId: string
	): Promise<any | IServerError | IResponse | null> => {
		const response: AxiosResponse<any[]> = await http.get<any[]>(
			`/v1/bc-eht-setting/bc-eht-setting-ddl`
		);
		if (response.status === 200) {
			return response.data;
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	archiveBCEHTSetting: async (
		archivePayload: any
	): Promise<string | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<string> = await http.post<string>(
				`/v1/bc-eht-setting/${archivePayload.bCEHTSettingId}/`
			);

			if (response.status === 201) {
				return "bc eht setting has been archived successfully";
			} else if (response.status === 200) {
				return "bc eht setting has been archived successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				archivePayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
		
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
